export default __webpack_public_path__ + "static/media/banner_18junio_sct_antp.5c405161.jpg";